export default __webpack_public_path__ + "static/media/upload.2b403286.svg";